export default {
  track: (eventName: string, properties?: Record<string, any>) => {
    window.collectEvent(eventName, properties ?? {})
  }
}
